<template>
  <div class="row">
    <div class="col-sm-6">
      <WhatsappForm />
    </div>
    <div class="col-sm-6">
      <WhatsappPreview />
    </div>
  </div>
</template>

<script>
import WhatsappForm from "./components/WhatsappForm";
import WhatsappPreview from "./components/WhatsappPreview";
export default {
  data() {
    return {};
  },
  components: {
    WhatsappForm,
    WhatsappPreview
  }
};
</script>
